<template>
  <div>
    <!-- 新增按钮 -->

    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
      :options="options3"
    ></DatePicker>
    <Button type="primary" @click="resetFormData">清除</Button>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
import { getCensusData } from "../../api/user";

export default {
  components: {},
  data() {
    return {
      selUser: {},
      reasontxt: "",
      amount: 0, // 输入的金额或者能量
      isfengjin: false,

      searchDate: [],
      loading: false,
      beizhu: "",
      clickuserid: "",
      lianxu: "",
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "日期",
          key: "createtime",
        },
        {
          title: "金币总余额",
          key: "totalBalance",
          render: (h, params) => {
            return h("span", params.row.totalBalance || '0');
          }
        },
        {
          title: "充值获得金币",
          key: "recharge_get_coin",
          render: (h, params) => {
            return h("span", params.row.recharge_get_coin || '0');
          }
        },
        {
          title: "分解获得金币",
          key: "split_get_coin",
          render: (h, params) => {
            return h("span", params.row.split_get_coin || '0');
          }
        },
        {
          title: "营业赠送金币",
          key: "sys_get_coin",
          render: (h, params) => {
            return h("span", params.row.sys_get_coin || '0');
          }
        },
        {
          title: "注册赠送",
          key: "regis_get_coin",
          render: (h, params) => {
            return h("span", params.row.regis_get_coin || '0');
          }
        },
        {
          title: "任务获得",
          key: "task_get_coin",
          render: (h, params) => {
            return h("span", params.row.task_get_coin || '0');
          }
        },{
          title: "周卡领取",
          key: "weekGetCoin",
          render: (h, params) => {
            return h("span", params.row.weekGetCoin || '0');
          }
        },{
          title: "月卡领取",
          key: "monthGetCoin",
          render: (h, params) => {
            return h("span", params.row.monthGetCoin || '0');
          }
        },{
          title: "升级奖励",
          key: "uplvGetCoin",
          render: (h, params) => {
            return h("span", params.row.uplvGetCoin || '0');
          }
        },{
          title: "福利金奖励(hvip&rank)",
          key: "heightlvGetCoin",
          render: (h, params) => {
            return h("span", params.row.heightlvGetCoin || '0');
          }
        },{
          title: "主播邀请送币",
          key: "zhuboGetCoin",
          render: (h, params) => {
            return h("span", params.row.zhuboGetCoin || '0');
          }
        },
        {
          title:"活动赠送金币",
          key: "activity_coin",
          render: (h, params) => {
            return h("span", params.row.activity_coin || '0');
          }
        },{
          title: "邀请付费充值奖励",
          key: "inviteGetCoin",
          render: (h, params) => {
            return h("span", params.row.inviteGetCoin || '0');
          }
        },{
          title: "徽章分解",
          key: "medalGetCoin",
          render: (h, params) => {
            return h("span", params.row.medalGetCoin || '0');
          }
        },
        {
          title: "游戏获得",
          key: "game_get_coin",
          render: (h, params) => {
            return h("span", params.row.game_get_coin || '0');
          }
        },{
          title: "游戏奖励",
          key: "gamerewardCoin",
          render: (h, params) => {
            return h("span", params.row.gamerewardCoin || '0');
          }
        },
        {title: '能量换币',key: 'coin_get_power',render: (h, params) => {
            return h("span", params.row.coin_get_power || '0');
          }},
        {
          title: "营业扣除金币",
          key: "sys_del_coin",
          render: (h, params) => {
            return h("span", params.row.sys_del_coin || '0');
          }
        },
        {
          title: "娃娃机消费金币",
          key: "doll_del_coin",
          render: (h, params) => {
            return h("span", params.row.doll_del_coin || '0');
          }
        },
        {
          title: "魔鬼城消费金币",
          key: "mgc_del_coin",
          render: (h, params) => {
            return h("span", params.row.mgc_del_coin || '0');
          }
        },
        {
          title: "推币机消费金币",
          key: "pushcoin_del_coin",
          render: (h, params) => {
            return h("span", params.row.pushcoin_del_coin || '0');
          }
        },
      ],

      current: 1,
      total: 0,
      options3: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 将时间设置为当天的开始
          return date && date.getTime() > today.getTime() - 1;
        },
      },
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    close() {
      this.visible = false;
    },
    // disabledDate(date) {
    //   // 禁止选择今天及以后的日期

    // },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      getCensusData(params)
        .then((response) => {
          this.data9 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.totalPages; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        starttime,
        endtime,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },

    resetFormData() {
      // 重置表单数据
      this.searchId = "";
      this.searchName = "";
      this.searchPhone = "";
      this.searchDate = [];
      this.current = 1;
      this.queryGoods();
    },
  },
};
</script>
